import type { Messages } from '../messages'

export const pa: Messages = {
  meta: {
    title: 'ਵਿਭਾ ਸ਼ਰਮਾ — ਪੋਰਟਫੋਲੀਓ',
    description:
      'ਡਾਟਾ ਵਿਗਿਆਨੀ — ਪਾਵਰ BI, SQL, ਪਾਇਥਨ, ਜਨਤਕ ਅਤੇ ਉਦਯੋਗਿਕ ਖੇਤਰਾਂ ਵਿੱਚ ਵਿਸ਼ਲੇਸ਼ਣ।',
  },
  nav: {
    about: 'ਬਾਰੇ',
    projects: 'ਪ੍ਰੋਜੈਕਟ',
    experience: 'ਤਜਰਬਾ',
    contact: 'ਸੰਪਰਕ',
    skipToContent: "ਸਮੱਗਰੀ 'ਤੇ ਜਾਓ",
  },
  hero: {
    role: 'ਡਾਟਾ ਵਿਗਿਆਨੀ',
    location: 'ਓਟਾਵਾ, ਓਨਟਾਰੀਓ, ਕਨੇਡਾ',
    tagline:
      'ਡਾਟੇ ਨੂੰ ਫੈਸਲਿਆਂ ਵਿੱਚ ਬਦਲਣਾ — ਪਾਵਰ BI, SQL ਅਤੇ NoSQL, ਪਾਇਥਨ, ਅੰਕੜੇ ਅਤੇ ਡਾਟਾ ਤਿਆਰੀ; ਵਿੱਤ, ਸਿਹਤ, ਖੇਤੀਬਾੜੀ ਅਤੇ ਜਨਤਕ ਖੇਤਰ ਵਿੱਚ।',
    ctaPrimary: 'ਤਜਰਬਾ ਵੇਖੋ',
    ctaSecondary: 'ਸੰਪਰਕ ਕਰੋ',
  },
  about: {
    title: 'ਬਾਰੇ',
    portraitAlt: 'ਵਿਭਾ ਸ਼ਰਮਾ ਦਾ ਪੇਸ਼ੇਵਰ ਚਿੱਤਰ',
    lead:
      'ਮਾਈਕ੍ਰੋਸਾਫਟ ਪਾਵਰ BI, SAP BusinessObjects ਅਤੇ ਮਾਈਕ੍ਰੋਸਾਫਟ BI ਸਟੈਕ ਨਾਲ ਪੰਜ ਸਾਲਾਂ ਦੇ ਹੱਥੋਂ-ਹੱਥ ਅਨੁਭਵ ਵਿੱਚ, ਮੈਂ ਕੱਚੇ ਡਾਟੇ ਨੂੰ ਵੱਖ-ਵੱਖ ਉਦਯੋਗਾਂ ਵਿੱਚ ਕਾਰਗਰ ਅੰਤਰਦ੍ਰਿਸ਼ਟੀ ਵਿੱਚ ਬਦਲਦੀ ਹਾਂ।',
    p1:
      'ਮੈਂ ਵਿੱਤ, ਸਿਹਤ ਸੇਵਾ ਅਤੇ ਖੇਤੀਬਾੜੀ ਵਿੱਚ ਕੰਮ ਕੀਤਾ ਹੈ ਅਤੇ ਇੱਕ ਡਾਟਾ ਵਿਗਿਆਨੀ ਵਜੋਂ ਡੋਮੇਨ-ਵਿਸ਼ੇਸ਼ ਚੁਣੌਤੀਆਂ ਨੂੰ ਸਮਝਦੀ ਹਾਂ। ਰਿਲੇਸ਼ਨਲ ਅਤੇ ਬਹੁ-ਪੱਖੀ ਡਾਟਾਬੇਸ, ਸਿਸਟਮ ਅਤੇ ਡਾਟਾ ਇਕੀਕਰਨ, ਰਿਪੋਰਟਿੰਗ, ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਮਜ਼ਬੂਤ ਡਾਟਾ ਪ੍ਰਬੰਧਨ ਮੇਰੇ ਮੁੱਖ ਬਲ ਹਨ।',
    p2:
      'ਟਰਾਂਸਪੋਰਟ ਕਨੇਡਾ, ਖੇਤੀਬਾੜੀ ਅਤੇ ਖਾਦ-ਖੇਤੀ ਕਨੇਡਾ ਅਤੇ ਵਿਪਰੋ ਲਿਮਟਿਡ ਵਿੱਚ ਰੋਲਾਂ ਨੇ ਜਨਤਕ ਅਤੇ ਨਿੱਜੀ ਸੰਗਠਨਾਂ ਵਿੱਚ ਡਾਟਾ-ਆਧਾਰਿਤ ਫੈਸਲਿਆਂ ਪ੍ਰਤੀ ਮੇਰੀ ਸ਼ਰਧਾ ਨੂੰ ਹੋਰ ਮਜ਼ਬੂਤ ਕੀਤਾ ਹੈ।',
    clearance:
      '2030 ਤੱਕ ਵੈਧ ਕਨੇਡੀਅਨ ਰਿਲਾਇਬਿਲਿਟੀ ਕਲੀਅਰੈਂਸ — ਸੁਰੱਖਿਆ ਅਤੇ ਗੋਪਨੀਅਤਾ ਪ੍ਰਤੀ ਵਚਨਬੱਧਤਾ।',
    stats: {
      years: '6+ ਸਾਲ ਦਾ ਅਨੁਭਵ',
      domains: 'ਵਿੱਤ · ਸਿਹਤ · ਖੇਤੀਬਾੜੀ · ਜਨਤਕ ਖੇਤਰ',
      clearanceLabel: 'ਰਿਲਾਇਬਿਲਿਟੀ ਕਲੀਅਰੈਂਸ',
    },
  },
  projects: {
    title: 'ਪ੍ਰੋਜੈਕਟ ਅਤੇ ਮੁੱਖ ਨੁਕਤੇ',
    subtitle:
      'ਮੇਰੀਆਂ ਭੂਮਿਕਾਵਾਂ ਤੋਂ ਪ੍ਰਤੀਨਿਧ ਕੰਮ — ਡੈਸ਼ਬੋਰਡ, ਇਕੀਕਰਨ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣ ਡਿਲਿਵਰੀ।',
    items: {
      aafc: {
        title: 'ਖੇਤੀਬਾੜੀ ਅਤੇ ਜਨਤਕ ਵਿਸ਼ਲੇਸ਼ਣ',
        period: '2023 — ਮੌਜੂਦਾ',
        summary:
          'ਖੇਤੀਬਾੜੀ ਅਤੇ ਖਾਦ-ਖੇਤੀ ਕਨੇਡਾ ਲਈ ਡਾਟਾ ਵਿਗਿਆਨ ਅਤੇ ਬਿਜ਼ਨਸ ਇੰਟੈਲੀਜੈਂਸ — ਵੱਡੀ ਸਰਕਾਰੀ ਏਜੰਸੀ ਵਿੱਚ ਖੋਜ-ਸੰਗਤ ਵਿਸ਼ਲੇਸ਼ਣ, ਰਿਪੋਰਟਿੰਗ ਅਤੇ ਡਾਟਾ ਹੱਲ।',
        tags: 'ਪਾਵਰ BI · ਡਾਟਾ ਇਕੀਕਰਨ · ਜਨਤਕ ਖੇਤਰ',
      },
      transport: {
        title: 'ਟਰਾਂਸਪੋਰਟ ਕਨੇਡਾ — ਪਾਵਰ BI ਡਿਲਿਵਰੀ',
        period: '2020 — 2022',
        summary:
          'ਪਾਵਰ BI ਅਤੇ ਪਾਵਰ ਪਿਵਟ ਵਿੱਚ ਜਟਿਲ DAX, ਮਾਡਲ ਕੀਤੇ ਡਾਟਾਸੈੱਟ, ਪਾਵਰ BI ਸਰਵਿਸ ਅਤੇ ਰਿਪੋਰਟ ਸਰਵਰ ਤੇ ਪ੍ਰਕਾਸ਼ਿਤ ਰਿਪੋਰਟਾਂ, ਸ਼ੇਅਰਪੁਆਇੰਟ ਇਕੀਕਰਨ, ਅਤੇ ਪਾਵਰਸ਼ੈੱਲ ਤੇ ਸ਼ਡਿਊਲਰ ਨਾਲ ਆਟੋਮੈਟਿਕ ਰਿਫਰੈਸ਼।',
        tags: 'DAX · ਪਾਵਰ ਕਵੇਰੀ · ਸ਼ੇਅਰਪੁਆਇੰਟ · ਆਟੋਮੇਸ਼ਨ',
      },
      wipro: {
        title: 'ਵਿਪਰੋ — ਕਰਾਸ-ਇੰਡਸਟਰੀ BI',
        period: '2015 — 2018',
        summary:
          'ਭੂ-ਸਥਾਨਿਕ ਅਤੇ ਸਿਹਤ ਸਮੇਤ ਵਿਭਿੰਨ ਡਾਟਾ ਤੇ ਪਾਵਰ BI ਅਤੇ ਵੈਬੀ ਰਿਪੋਰਟਾਂ, ਗ੍ਰਾਹਕ PoC, SAP BusinessObjects ਯੂਨੀਵਰਸ ਅਤੇ BI ਪਾਈਪਲਾਈਨ ਲਈ ਡਾਟਾ ਪ੍ਰੋਫਾਈਲਿੰਗ।',
        tags: 'SAP BO · ਸਿਹਤ · ਭੂ-ਸਥਾਨਿਕ · ਵੈਬੀ',
      },
    },
  },
  experience: {
    title: 'ਤਜਰਬਾ',
    workHistory: 'ਕੰਮ ਦਾ ਇਤਿਹਾਸ',
    education: 'ਸਿੱਖਿਆ',
    certifications: 'ਸਰਟੀਫਿਕੇਟ',
    jobs: {
      aafc_ds: {
        title: 'ਡਾਟਾ ਵਿਗਿਆਨੀ (ਸਥਾਈ)',
        org: 'ਖੇਤੀਬਾੜੀ ਅਤੇ ਖਾਦ-ਖੇਤੀ ਕਨੇਡਾ',
        period: 'ਅਪ੍ਰੈਲ 2024 — ਮੌਜੂਦਾ',
        location: 'ਓਟਾਵਾ, ਕਨੇਡਾ',
        bullets: [
          'ਸਰਕਾਰੀ ਖੋਜ ਅਤੇ ਨੀਤੀ ਸੰਦਰਭ ਵਿੱਚ ਡਾਟਾ ਵਿਗਿਆਨ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣ।',
          'ਮਾਈਕ੍ਰੋਸਾਫਟ BI ਇਕੋਸਿਸਟਮ ਅਤੇ ਸੰਬੰਧਿਤ ਡਾਟਾ ਪਲੇਟਫਾਰਮਾਂ ਤੇ ਨਿਰੰਤਰ ਡਿਲਿਵਰੀ।',
        ],
      },
      aafc_bi: {
        title: 'ਡਾਟਾ ਵਿਗਿਆਨੀ — ਬਿਜ਼ਨਸ ਇੰਟੈਲੀਜੈਂਸ ਵਿਸ਼ੇਸ਼ਜ्ञ',
        org: 'ਖੇਤੀਬਾੜੀ ਅਤੇ ਖਾਦ-ਖੇਤੀ ਕਨੇਡਾ',
        period: 'ਜੁਲਾਈ 2023 — ਅਪ੍ਰੈਲ 2024',
        location: 'ਓਟਾਵਾ, ਕਨੇਡਾ',
        bullets: ['ਖੋਜ ਵਿਭਾਗ ਅੰਦਰ ਵਿਸ਼ੇਸ਼ਜ्ञ-ਪੱਧਰ ਦੀ BI ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣ।'],
      },
      tc: {
        title: 'ਪ੍ਰੋਗਰਾਮਰ ਵਿਸ਼ਲੇਸ਼ਕ',
        org: 'ਟਰਾਂਸਪੋਰਟ ਕਨੇਡਾ',
        period: 'ਜੂਨ 2020 — ਮਾਰਚ 2022',
        location: 'ਓਟਾਵਾ, ਕਨੇਡਾ',
        bullets: [
          'ਪਾਵਰ BI ਅਤੇ ਪਾਵਰ ਪਿਵਟ ਲਈ ਉੱਨਤ DAX; ਕੰਪਿਊਟਿਡ ਟੇਬਲ ਅਤੇ ਵਿਜ਼ੂਅਲ।',
          'ਪਾਵਰ BI ਸਰਵਿਸ ਅਤੇ ਰਿਪੋਰਟ ਸਰਵਰ ਤੇ ਪ੍ਰਕਾਸ਼ਨ; ਸ਼ੇਅਰਪੁਆਇੰਟ ਔਨਲਾਈਨ ਐਕਸੈਸ।',
          'ਪਾਵਰਸ਼ੈੱਲ ਅਤੇ ਵਿੰਡੋਜ਼ ਟਾਸਕ ਸ਼ਡਿਊਲਰ ਰਾਹੀਂ ਪਾਵਰ ਕਵੇਰੀ ਰਿਫਰੈਸ਼ ਆਟੋਮੇਟਿਡ।',
        ],
      },
      wipro: {
        title: 'ਡਾਟਾ ਵਿਗਿਆਨੀ',
        org: 'ਵਿਪਰੋ ਲਿਮਟਿਡ',
        period: 'ਦਸੰਬਰ 2015 — ਅਗਸਤ 2018',
        location: 'ਗੁੜਗਾਓ, ਭਾਰਤ',
        bullets: [
          'ਭੂ-ਸਥਾਨਿਕ ਅਤੇ ਸਿਹਤ ਸਮੇਤ ਵਿਭਿੰਨ ਡਾਟਾ ਤੇ ਪਾਵਰ BI ਅਤੇ ਵੈਬੀ।',
          'ਗ੍ਰਾਹਕ PoC, ਡਾਟਾ ਵੇਰਹਾਊਸ ਤੋਂ SAP BO ਯੂਨੀਵਰਸ, ਅਤੇ BI ਲਈ ਡਾਟਾ ਪ੍ਰੋਫਾਈਲਿੰਗ।',
        ],
      },
    },
    edu: {
      masters: {
        degree: 'ਮਾਸਟਰ ਡਿਗਰੀ, ਸੂਚਨਾ ਤਕਨੀਕ',
        school: 'ਓਟਾਵਾ ਯੂਨੀਵਰਸਿਟੀ',
        period: '2018 — 2020',
        detail: 'ਕਨੇਡਾ',
      },
      bachelors: {
        degree: 'ਸਨਾਤਕ ਡਿਗਰੀ, ਸੂਚਨਾ ਤਕਨੀਕ',
        school: 'ਚੰਡੀਗੜ੍ਹ ਇੰਜੀਨੀਅਰਿੰਗ ਕਾਲਜ, ਲੰਦਰਾਂ',
        period: '2011 — 2015',
      },
    },
    certs: {
      pbi: {
        name: 'ਪਾਵਰ BI ਜ਼ਰੂਰੀ ਟ੍ਰੇਨਿੰਗ',
        issuer: 'ਲਿੰਕਡਇਨ ਲਰਨਿੰਗ',
        issued: 'ਅਕਤੂਬਰ 2022',
      },
      ssis: {
        name: 'SQL ਸਰਵਰ ਇੰਟੀਗ੍ਰੇਸ਼ਨ ਸਰਵਿਸਿਜ਼',
        issuer: 'ਲਿੰਕਡਇਨ ਲਰਨਿੰਗ',
        issued: 'ਅਕਤੂਬਰ 2022',
      },
    },
  },
  contact: {
    title: 'ਸੰਪਰਕ',
    subtitle:
      'ਡਾਟਾ, ਵਿਸ਼ਲੇਸ਼ਣ ਜਾਂ ਸਹਿਯੋਗ ਦੇ ਮੌਕਿਆਂ ਬਾਰੇ ਗੱਲਬਾਤ ਦਾ ਮੈਂ ਸੁਆਗਤ ਕਰਦੀ ਹਾਂ।',
    emailLabel: 'ਈਮੇਲ',
    linkedinLabel: 'ਲਿੰਕਡਇਨ',
    locationLabel: 'ਸਥਾਨ',
    formNote: 'ਈਮੇਲ ਜਾਂ ਲਿੰਕਡਇਨ ਰਾਹੀਂ ਸੰਪਰਕ ਕਰੋ — ਜਦੋਂ ਸੰਭਵ ਹੋਵੇ ਮੈਂ ਜਵਾਬ ਦਿੰਦੀ ਹਾਂ।',
  },
  footer: {
    rights: '© ਵਿਭਾ ਸ਼ਰਮਾ।',
    builtWith: 'React ਅਤੇ Vite ਨਾਲ ਬਣਾਇਆ ਗਿਆ',
  },
  controls: {
    theme: 'ਥੀਮ',
    themeLight: 'ਲਾਈਟ',
    themeDark: 'ਡਾਰਕ',
    themeEnhanced: 'ਵਧੀਕ ਡਾਰਕ',
    language: 'ਭਾਸ਼ਾ',
  },
}
